import { render, staticRenderFns } from "./VPlayerDialog.vue?vue&type=template&id=4bb97f2c&"
import script from "./VPlayerDialog.vue?vue&type=script&lang=ts&"
export * from "./VPlayerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports